import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
`;

export const PercentageText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const ProgressBar = styled.div<{ barWidth?: string }>`
  height: 8px;
  width: ${({ barWidth }) => (barWidth ? barWidth : '300px')};
  background: ${(props) =>
    props.theme.atlas.semantic.color.action.primary.disabled};
  border-radius: 4px;
  margin-right: 8px;
`;

export const ProgressBarFiller = styled.div<{
  percentage: number;
  error?: boolean;
}>`
  height: 8px;
  width: ${({ percentage }) => (percentage > 100 ? 100 : percentage)}%;
  background: ${(props) =>
    props.error
      ? props.theme.atlas.semantic.color.action.destructive.default
      : props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 4px;
`;
